import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";

export default function Problem() {
  const { t } = useLang();
  const marqueeText = t.problem.marquee;
  const items = Array.from({ length: 8 });

  return (
    <section id="problem" className="relative py-24 md:py-40 bg-charcoal overflow-hidden" data-testid="problem-section">
      {/* editorial marquee */}
      <div className="relative overflow-hidden select-none py-4 mb-16 md:mb-24" aria-hidden="true">
        <div className="flex whitespace-nowrap animate-marquee will-change-transform">
          {items.concat(items).map((_, i) => (
            <span
              key={i}
              className="font-display font-black lowercase text-5xl md:text-8xl mx-6 text-crema/10"
            >
              {marqueeText} <span className="text-coral/40">·</span>
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-5 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-black tracking-tight leading-[1.02] text-crema text-4xl md:text-6xl max-w-3xl"
          data-testid="problem-headline"
        >
          {t.problem.headline}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-8 max-w-2xl text-lg md:text-xl leading-relaxed text-crema/60"
          data-testid="problem-body"
        >
          {(() => {
            const body = t.problem.body.trim();
            const idx = body.lastIndexOf(". ");
            if (idx === -1) return body;
            const head = body.slice(0, idx + 2);
            const punch = body.slice(idx + 2);
            return (
              <>
                {head}
                <span className="text-teal font-semibold">{punch}</span>
              </>
            );
          })()}
        </motion.p>
      </div>
    </section>
  );
}
